import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {trigger, style, animate, transition} from '@angular/animations';
import {Router} from "@angular/router";
import {ClientService} from "../../services/client.service";

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    animations: [
        trigger('dialog', [
            transition('void => *', [
                style({ transform: 'scale3d(.3, .3, .3)' }),
                animate(100)
            ]),
            transition('* => void', [
                animate(100, style({ transform: 'scale3d(.0, .0, .0)' }))
            ])
        ])
    ]
})

export class ModalComponent implements OnInit {

    @Input() visible: boolean;
    @Input() closeAction: string;
    @Input() modalId: string;
    @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    closable = true;

    constructor(private router: Router) {
    }

    ngOnInit(): void {
    }

    close() {
        document.getElementById(this.modalId).classList.add('d-none');
        if (this.closeAction === 'navigateToHome') {
            this.router.navigateByUrl('');
        } else if (this.closeAction === 'navigateToPersonalData') {
            this.router.navigateByUrl('datos');
        }
    }
}
